import React, { useState, useEffect ,Suspense} from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { getApi } from '../../../Services/apiService';
import EditUserModal from './editUser';
import DeleteModal from '../../SharedComponents/deleteModal';

const UserManagement = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [filterQuery, setFilterQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null); // New state for storing selected user ID


  // Function to fetch users
  const fetchUsers = async () => {
	if(query==''){
    setLoading(true);
	}
    setError(null);

    try {
      const response = await getApi(
        `/admin/users?search=${query}&per_page=50`
      );
      if (response && response.statusCode === 200) {
        setUsers(response?.data || []);
      } else {
        throw new Error('Failed to fetch users.');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetchUsers();
  }, [query,editUserModal,deleteModal]); // Fetch users on component mount

  // Handle search input change
  const handleSearchChange = (event) => {
    setQuery(event.target.value);
    // fetchUsers();  // Trigger the search immediately after keyup
  };
  const openModal = (selectedUser) => {
    setSelectedUserId(selectedUser); // Store the selected user ID
    setEditUserModal(true);
};
const openDeleteUserModal = (id) => {
  setSelectedUserId(id); // Store the selected user ID
  setDeleteModal(true);  // Open the delete modal
};
const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};
  return (
    <div className='RightSideDiv'>
      <div className="right-top">
	  <input
          type="text"
          className="search-input"
          placeholder="Search . . ."
          value={query}
          onChange={handleSearchChange}  // Changed to keyup event
        />
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="error-message">{error}</p>}

      <div className="table-outer">
        <table className="table">
          <thead>
            <tr className="t-heading">
              <th className="date"><h5>Sr.No</h5></th>
              <th className="order"><h5>User Name</h5></th>
              <th className="info"><h5>User Email</h5></th>
              <th className="reference"><h5>Joined On</h5></th>
              <th className="total-amount"><h5>Subscription</h5></th>
              <th className="order-status"><h5>Action</h5></th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              users.map((user, index) => (
                <tr className="green" key={user.id || index}>
                  <td className="date">
                    <h5>#{index +1}</h5>
                  </td>
                  <td className="order">
				  <h5>{(user.first_name) }  {(user.last_name)}</h5>
                    {/* <span className="user-img">
                      <img
                        src={user.profileImage || '/default-avatar.png'}
                        alt="User"
                        className="user-avatar"
                      />
                    </span> */}
                  </td>
                  <td className="info">
                    <h5>{user?.email || 'N/A'}</h5>
                  </td>
                  <td className="reference">
                    <h5>{formatDate(user?.createdAt) || 'NA'}</h5>
                  </td>
                  <td className="total-amount">
                    <h5>N/A</h5>
                  </td>
                  <td className="action">
                    <button onClick={() => navigate(`/users/${user.id}`)}>
                      <img src={window.getPublicUrl("/assets/images/view.svg")} alt="View" />
                    </button>
                    <button className="edit" onClick={() => { openModal(user) }}>
                      <img src={window.getPublicUrl("/assets/images/edit.svg")} alt="Edit" />
                    </button>
                    <button onClick={() => { openDeleteUserModal(user?.id) }}>
                      <img src={window.getPublicUrl("/assets/images/delete.svg")} alt="Delete" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>
                  No users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Suspense fallback={<div>Loading...</div>}>
                <Modal isOpen={editUserModal} onRequestClose={() => setEditUserModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
                    overlayClassName={`modal-overlay add-category delete logout `}
                    portalClassName="add-user edit">
                    <EditUserModal setEditUserModal={setEditUserModal} userDetails ={selectedUserId}/>
                </Modal>
                </Suspense>

                <Suspense fallback={<div>Loading...</div>}>

                <Modal isOpen={deleteModal} onRequestClose={() => setDeleteModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
                    overlayClassName={`modal-overlay add-category delete logout `}
                    portalClassName="add-user delete">
                    <DeleteModal setDeleteModal={setDeleteModal}  userDetails ={selectedUserId} title={'this user'} comp={'user'}/>
                </Modal>
                </Suspense>
    </div>

    
  );
};

export default UserManagement;
